import { Typography } from "@mui/material";
import ReplacementDiffModal from "./ReplacementDiffModal";

type TemplateReplacementModalProps = {
  open: boolean;
  currentItem: ItemWithBOM;
  replacementItem: ItemWithBOM | null;
  errorMessage?: string | null;
  onCancel: () => void;
  onConfirm: () => void;
};

const TemplateReplacementModal = ({
  open,
  currentItem,
  replacementItem,
  errorMessage,
  onCancel,
  onConfirm,
}: TemplateReplacementModalProps) => {
  return (
    <ReplacementDiffModal
      open={open}
      title="Template Replacement Confirmation"
      description="Review the differences before replacing the item with the selected template."
      currentItem={currentItem}
      replacementItem={replacementItem}
      preDiffContent={
        errorMessage ? (
          <Typography variant="body2" sx={{ color: "#d32f2f" }}>
            {errorMessage}
          </Typography>
        ) : undefined
      }
      confirmDisabled={Boolean(errorMessage)}
      onCancel={onCancel}
      onConfirm={onConfirm}
    />
  );
};

export default TemplateReplacementModal;
